<p-toast></p-toast>
<div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
  <div class="md:col-5 lg:col-4 col-12 p-0 md:pr-3 flex flex-column gap-4">
    <div class="flex flex-column gap-3">
      <b class="text-xl font-bold">My Colleges</b>
      <div class="flex flex-column gap-2">
        <div *ngFor="let institute of myInstitutes;"
          class="flex align-items-center justify-content-between gap-1 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100 pr-1">
          <p-button styleClass="essay_btn flex-1"
            (click)="loadInstituteCheckList(institute)"
            class="flex-1 flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900">
            <span>{{institute.instituteName}}</span>
            <i class="pi pi-angle-right"></i>
          </p-button>
          <button
            (click)="deleteCollege(institute)"
            title="Remove college"
            style="background:transparent;border:none;cursor:pointer;padding:4px 6px;color:#c94040;border-radius:6px;display:flex;align-items:center;flex-shrink:0;"
            onmouseover="this.style.background='#fff0f0'" onmouseout="this.style.background='transparent'">
            <i class="pi pi-trash" style="font-size:0.85rem;"></i>
          </button>
        </div>
      </div>

      <div class="w-full mt-2">
        <div (click)="openAdditionalInfo()"
          class="w-full flex align-items-center justify-content-between py-2 px-3 cursor-pointer"
          style="background-color: #CDD12A; border-radius: 8px;">
          <h2 class="text-left font-medium text-lg">Task</h2>
          <a class="flex-shrink-0 py-2 p-3 bg-white border-round-2xl"><i class="pi pi-list-check"></i> Checklist</a>
        </div>
      </div>
    </div>
  </div>
  <div class="md:col-7 lg:col-8 col-12 p-0 md:pl-3">
    <!-- Loading Spinner -->
    <!-- <div  class="flex gap-4 align-items-center justify-content-center py-5">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
          animationDuration=".5s"></p-progressSpinner>
      </div> -->

    <!-- Message when not loading and no degree preference -->


    <!-- Main Content when degree preference exists -->
    <div *ngIf="currentSelectedTab==selectedTab.checkList">
      <div *ngIf="!isLoading && applyingForLevel!==null" class="flex flex-column gap-4">
        <div *ngIf="selectedInstitute && selectedInstitute!=null"
          class="flex-column sm:flex-row md:flex-column lg:flex-row flex align-items-center gap-3 justify-content-between border-1 border-round-lg p-3 border-bluegray-200 bg-white">
          <div class="flex align-items-center gap-3 flex-shrink-0">
            <div class="w-5rem h-5rem overflow-hidden border-circle flex-shrink-0">
              <img
                [src]="selectedInstitute.logo ? selectedInstitute.logo : '../../../assets/images/logo-placeholder.png'"
                alt="" class="w-full h-full" style="object-fit: cover;">
            </div>
            <div class="flex-1 flex flex-column gap-1">
              <b class="text-left font-medium text-2xl" style="color: #052647;">{{selectedInstitute.instituteName}}</b>
              <p class="text-left font-normal text-base" style="color: #575B68;">
                {{selectedInstitute? (selectedInstitute.city + ', '+ selectedInstitute.country): ''}}
              </p>
            </div>
          </div>
          <div class="flex flex-column gap-1 w-full max-w-20rem">
            <b class="font-medium text-2xl text-center" style="color: #052647;">{{ daysLeft && daysLeft > 0 ?
              daysLeft.toString() : '0' }} Days Left</b>
            <p class="font-normal text-base text-center" style="color: #515151;">Submit your application before
              {{selectedInstitute.applicationDeadlineRegularDecision}}</p>
          </div>
        </div>
        <form [formGroup]="checklistForm">
          <div *ngIf="instituteCheckList" class="w-full flex flex-column gap-4">
            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #FCFDF0; border-color: #CDD12A;">
              <div class="w-full flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                  <b class="text-xl font-medium">Essay</b>
                </div>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let essayPilot of instituteCheckList.essayPilot;">
                    <p-checkbox [value]="essayPilot" [inputId]="essayPilot" formControlName="essayPilot"
                      [label]="essayPilot" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('essayPilot')?.invalid &&
                  (submitted || checklistForm.get('essayPilot')?.touched)">
                  Select Essay Pilot
                </small>
              </div>
              <div class="w-full flex flex-column gap-2 pt-3" style="border-top: 1px solid #ddd;">
                <b class="text-xl font-medium">LOR</b>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let lor of instituteCheckList.loRs;">
                    <p-checkbox [value]="lor" [inputId]="lor" formControlName="lORs" [label]="lor" styleClass="checkbox"
                      labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('lORs')?.invalid &&
                  (submitted || checklistForm.get('lORs')?.touched)">
                  Select LORs
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #F8F7FF; border-color: #B3B2DA;">
              <div class="w-full flex flex-column gap-2">
                <div class="flex align-items-center  gap-2">
                  <b class="text-xl font-medium">Personal Documents</b>
                </div>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let personalDocument of instituteCheckList.personalDocuments;">
                    <p-checkbox [value]="personalDocument" [inputId]="personalDocument"
                      formControlName="personalDocuments" [label]="personalDocument" styleClass="checkbox"
                      labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>

                <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('personalDocuments')?.invalid &&
                  (submitted || checklistForm.get('personalDocuments')?.touched)">
                  Select Personal Dcouments
                </small>
              </div>
              <div class="w-full flex flex-column gap-2 pt-3" style="border-top: 1px solid #ddd;">
                <b class="text-xl font-medium">Test Scores</b>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let testScore of instituteCheckList.testScores;">
                    <p-checkbox [value]="testScore" [inputId]="testScore" formControlName="testScores"
                      [label]="testScore" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('testScores')?.invalid &&
                  (submitted || checklistForm.get('testScores')?.touched)">
                  Select Test Scores
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #FCFDF0; border-color: #CDD12A;">
              <div class="w-full flex flex-column gap-2">
                <b class="text-xl font-medium">Financial Aid/Scholarship</b>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let financialAid of instituteCheckList.financialAid;">
                    <p-checkbox [value]="financialAid" [inputId]="financialAid" formControlName="financialAids"
                      [label]="financialAid" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>

                <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('financialAids')?.invalid &&
                  (submitted || checklistForm.get('financialAids')?.touched)">
                  Select Financial Aid
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #F8F7FF; border-color: #B3B2DA;">
              <div class="w-full flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                  <b class="text-xl font-medium">Application Form</b>
                </div>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let appnForm of instituteCheckList.applicationForms;">
                    <p-checkbox [value]="appnForm" [inputId]="appnForm" formControlName="applicationForms"
                      [label]="appnForm" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>

                <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('applicationForms')?.invalid &&
                  (submitted || checklistForm.get('applicationForms')?.touched)">
                  Select Form
                </small>
              </div>
            </div>
            <div class="flex align-items-center justify-content-end">
              <p-button label="Save" class="w-full sm:w-12rem" styleClass="save_btn"
                (onClick)="saveStudentChecklist()" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <app-additional-information-right-section *ngIf="currentSelectedTab === selectedTab.additionalInfo"
      [infoType]="infotype.CheckList"></app-additional-information-right-section>
  </div>
</div>